<template>
  <section id="try-it" class="try-it">
    <h1 class="section-title">Protected by the Mafia Boss</h1>
    <div>
      <i
        >The Player overhears a dangerous conversation between two of Adrian's
        enemies while taking the trash out at Luxe Nightclub. Adrian intervenes
        to rescue her.</i
      >
    </div>
    <CoolButton @click="startBot('penthouse')" v-if="!botStarted">
      Start Scenario</CoolButton
    >
    <!-- <div
      class="try-it-container"
      ref="scrollContainer"
      @mousedown="startDrag"
      @mousemove="onDrag"
      @mouseup="stopDrag"
      @mouseleave="stopDrag"
    >
      <div data-aos="flip-left" class="use-case-box-parent">
        <div class="use-case-box">
          <div class="icon">💼</div>
          <h3 class="use-case-title">New York City</h3>
          <p class="use-case-description"></p>
          <CoolButton @click="startBot('new_york_city')">
            Load Scenario</CoolButton
          >
        </div>
      </div>

      <div
        data-aos="flip-left"
        data-aos-delay="300"
        class="use-case-box-parent"
      >
        <div class="use-case-box">
          <div class="icon">🤖</div>
          <h3 class="use-case-title">Luxe Nightclub</h3>
          <p class="use-case-description"></p>
          <CoolButton @click="startBot('luxe_nightclub')">
            Load Scenario</CoolButton
          >
        </div>
      </div>
      <div
        data-aos="flip-left"
        data-aos-delay="600"
        class="use-case-box-parent"
      >
        <div class="use-case-box">
          <div class="icon">🌐</div>
          <h3 class="use-case-title">Adrian's Brooklyn Penthouse</h3>
          <p class="use-case-description"></p>
          <CoolButton @click="startBot('penthouse')"> Load Scenario</CoolButton>
        </div>
      </div>
    </div>
    <CoolPanel class="separator" v-if="!botStarted"
    >Select Your Agent
</CoolPanel> -->
    <ChatSection class="chat" ref="chatbot" />
  </section>
</template>

<script>
// import CoolPanel from "./CoolPanel.vue";
import CoolButton from "./CoolButton.vue";
import ChatSection from "@/components/ChatSection.vue";
// import IsTyping from "./IsTyping.vue";
export default {
  components: {
    ChatSection,
    CoolButton,
    // CoolPanel,
    // IsTyping,
  },
  data() {
    return {
      botStarted: false,
    };
  },
  methods: {
    startBot(role) {
      this.$refs.chatbot.startBot(role);
      this.botStarted = true;
    },
  },
};
</script>

<style scoped>
/* Use Cases Section */

.chat {
  height: 100%;
}
.try-it {
  padding: 8dvh 50px 50px;
  min-height: 100dvh;
  background-color: #f9f9f9;
  text-align: center;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 0;
  margin-bottom: 10dvh;
  gap: 20px;
}

@media (max-width: 500px) {
  .try-it {
    padding: 8dvh 0px;
  }
}
.section-title {
  margin: 0;
  font-size: 2.5rem;
  color: var(--primary-color);
}

* {
  box-sizing: border-box;
}
</style>
